<template>
  <div class="c-serviceSearchHeaderFacetCassette">
    <BCheckbox
      v-model="innerValue"
      :native-value="cassette.value"
      :disabled="isDisabled"
      class="c-serviceSearchHeaderFacetCassette_button"
      :class="{
        'c-serviceSearchHeaderFacetCassette_button-hasIcon': isSearchIcon,
        'c-serviceSearchHeaderFacetCassette_button-isChecked': isChecked,
        'c-serviceSearchHeaderFacetCassette_button-isCheckboxHidden': !allowsMultipleSelect,
      }"
      :style="computedStyle"
    >
      <slot
        v-for="slotName in Object.keys($slots)"
        :name="slotName"
        :slot="slotName"
      />
    </BCheckbox>
  </div>
</template>
<script>
export default {
  name: 'ServiceSearchHeaderFacetCassette',
  props: {
    cassette: {
      type: Object,
      default: () => {}
    },
    allowsMultipleSelect: {
      type: Boolean,
      default: false
    },
    isSearchIcon: {
      type: Boolean,
      default: false
    },
    iconImage: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    },
    isScrolling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDisabled: false
    }
  },
  watch: {
    isScrolling(newValue) {
      if (!newValue) {
        setTimeout(() => {
          this.isDisabled = false
        }, 100)
      } else {
        this.isDisabled = true
      }
    }
  },
  computed: {
    computedStyle() {
      if (this.isSearchIcon) {
        return {
          backgroundImage: `url(${this.iconImage})`
        }
      }
      return null
    },
    innerValue: {
      get() {
        return this.option.value ? [this.option.value] : this.option.valuesList
      },
      set(val) {
        if (this.allowsMultipleSelect) {
          this.$emit('input', val)
        } else if (val.some(v => Number(v) === Number(this.cassette.value))) {
          this.$emit('input', [Number(this.cassette.value)])
        } else {
          this.$emit('input', [])
        }
      }
    },
    isChecked() {
      if (this.innerValue?.length > 0) {
        return this.innerValue.some(v => Number(v) === Number(this.cassette.value))
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceSearchHeaderFacetCassette {
  display: flex;
  width: 138px;
  min-width: 138px;
  height: 96px;

  align-items: flex-start;
  /deep/ .b-checkbox {
    &.checkbox {
      input[type='checkbox'] + .check {
        width: 12px;
        height: 12px;
        border-radius: 2px;
      }
      .control-label {
        padding-left: 4px;
      }
      &[disabled] {
        color: currentColor;
        opacity: 1;
        cursor: pointer;
      }
    }
  }

  &_button {
    display: flex;
    margin-right: 0 !important;
    padding: 8px 4px;
    width: 138px;
    height: 100%;
    border: 1px solid $color-gray-200;
    border-radius: 5px;
    box-shadow: 0 1px 1px rgba($color-black, 0.16), 0 0.5px 2px rgba($color-black, 0.12);
    background: $color-white no-repeat left top/100%;
    white-space: normal;
    line-height: 1.2;

    align-items: center;
    justify-content: center;
    &-hasIcon {
      padding-top: 64px;
      padding-bottom: 2px;
    }
    &-isChecked {
      border: 1px solid $color-blue-500;
    }
    &-isCheckboxHidden {
      /deep/ .check {
        display: none;
      }
    }
  }
}

@media (min-width: breakpoint(Search, M) + 1) {
  .c-serviceSearchHeaderFacetCassette {
    @include link-effect;
  }
}
</style>
